import { Box, Stack } from "@mui/material";

import { ShiftChipTag } from "./ShiftChipTag";
import { type ShiftChip } from "./types";
import { getShiftChipDataFromShiftChip, sortShiftChipData } from "./utils";

export interface ShiftChipBarProps {
  shiftChips: ShiftChip[];
}

export function ShiftChipBar(props: ShiftChipBarProps) {
  const { shiftChips } = props;
  const shiftChipData = sortShiftChipData(
    shiftChips.map((shiftChip) => getShiftChipDataFromShiftChip(shiftChip))
  );
  const spaceAroundChips = shiftChipData.length > 0 ? 1 : 0;

  return (
    <Stack
      aria-label="Shift Chip Bar"
      flex={1}
      flexDirection="row"
      flexWrap="wrap"
      paddingTop={spaceAroundChips}
    >
      {shiftChipData.map((singleShiftChipData) => (
        <Box key={singleShiftChipData.type} sx={{ marginBottom: 1, marginRight: 1 }}>
          <ShiftChipTag shiftChipData={singleShiftChipData} />
        </Box>
      ))}
    </Stack>
  );
}
